<div class="py-2 custom-card-wrap" style="display: inline-block; width: 100%" [class.h-100]="height100" [class.no-header-margin]="noHeaderMargin">

  <!-- getCustomBackground just injects the class set in Input 'backgroundClass' -->
  <div class="px-3 py-3 custom-card-subpage h-100" [ngClass]="getCustomBackground()">
    <!-- If height100 is set to true, this div is not shown (topbar)-->

    <div class="row" style="margin: 0;">
      <div class="col-xs-12 background-mobile dark-border">

        <div class="d-flex align-items-center justify-content-center">

          <!-- Here is the title -->
          <h2 class="text-color-primary" data-cy="page-title">{{ title | translate}}</h2>
        </div>

        <!-- Here is the subtitle -->
        <pre class="text-muted" style="text-align: center; white-space: pre-wrap;" data-cy="page-subtitle">{{ subtitle | translate}}</pre>
      </div>
    </div>
    <div class="col">
    </div>
    @if (!height100) {
      <div class="pt-3"></div>
    }
    <div [class.h-100]="height100" style="height: 100%">
      <!-- Content will be injected here (part between <app-default-layout> and </app-default-layout>) -->
      <ng-content></ng-content>
    </div>
  </div>
</div>
